module.exports = __webpack_public_path__ + "img/germany-external-causes-female.aee66449.png";